import PropTypes from 'prop-types';
import Pagination from 'components/controls/pagination';

const EmailControllerHeader = ({
  selectedCount = 0,
  totalCount = 0,
  label = '',
  page = 1,
  onPageChange = () => {},
  totalPages = 1,
  showPagination = true,
}) => {
  return (
    <div className="email-controller-header">
      <div className="email-controller-header-left">
        {selectedCount > 0 ? (
          <h5>
            <span className="bulk-select-count">{selectedCount}</span>&nbsp;{`Selected`}
          </h5>
        ) : (
          <h5>{`${totalCount} ${label}`}</h5>
        )}
      </div>
      {showPagination && (
        <div className="email-controller-header-center">
          <Pagination page={page} onChange={onPageChange} total={totalPages} />
        </div>
      )}
    </div>
  );
};

EmailControllerHeader.propTypes = {
  selectedCount: PropTypes.number,
  totalCount: PropTypes.number,
  label: PropTypes.string,
  page: PropTypes.number,
  onPageChange: PropTypes.func,
  totalPages: PropTypes.number,
  showPagination: PropTypes.bool,
};

export default EmailControllerHeader;
